import { Component, OnInit, ViewChild, AfterViewInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
@Component({
  selector: 'app-emspopuptable',
  templateUrl: './emspopuptable.component.html',
  styleUrls: ['./emspopuptable.component.scss']
})
export class EmspopuptableComponent implements OnInit, AfterViewInit {
  displayedColumns: string[] = ['TransformerID', 'SiteName', 'Communication', 'LastUpdatedTime', 'Status'];
  dataSource: MatTableDataSource<any>; // Using MatTableDataSource for sorting and paginator
  displayedColumnstwo: string[] = ['energyMeterId', 'DATE', 'parametername', 'actualvalue', 'thresholdvalue'];
  dataSourcetwo: MatTableDataSource<any>; // For the second table
  totalMeters: any[] = [];
  onlineMeters: any[] = [];
  offlineMeters: any[] = [];
  noAlertMeters: any[] = [];
  alertGeneratedMeters: any[] = [];
  type: string = '';
  alertsData: string;
  showstatus;
  alertsectiondata;
 @ViewChild(MatSort, { static: false }) sort: MatSort;
 @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator; // For the first table
 @ViewChild('paginatorTwo', { static: false }) paginatorTwo: MatPaginator; // For the second table
  constructor(
    private dialogRef: MatDialogRef<EmspopuptableComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
  ngOnInit() {
    this.type = this.data.type;
    this.showstatus = this.data.show;
    this.alertsectiondata = this.data.alldata;
this.dataSourcetwo = new MatTableDataSource<any>(this.alertsectiondata || []);
     this.processMeterData();
    this.filterData();
  }
  ngAfterViewInit() {
    // Link paginator and sort to the first table
    if (this.dataSource) {
      this.dataSource.paginator = this.paginator; // Ensure this is your first paginator
      this.dataSource.sort = this.sort; // Sorting for the first table
    } else {
      console.error('Data source for the first table not properly initialized');
    }
    // Link paginator and sort to the second table
    if (this.dataSourcetwo) {
      this.dataSourcetwo.paginator = this.paginatorTwo;
      this.dataSourcetwo.sort = this.sort; // Sorting for the second table, if needed
    } else {
      console.error('Data source for the second table not properly initialized');
    }
  }
  processMeterData() {
    if (this.data && this.data.allstatus && Array.isArray(this.data.allstatus)) {
      this.data.allstatus.forEach((meter: any) => {
        const { status, alertStatus } = meter;
        this.totalMeters.push(meter);
        if (status === 'Online') {
          this.onlineMeters.push(meter);
          if (alertStatus === 'No Alert') {
            this.noAlertMeters.push(meter);
          }
        } else if (status === 'Offline') {
          this.offlineMeters.push(meter);
        }
        if (alertStatus === 'Alert Generated') {
          this.alertGeneratedMeters.push(meter);
        }
      });
    } else {
      console.error('No meter data available or invalid data format');
    }
  }
  filterData() {
    let filteredData;
    switch (this.type) {
      case 'online':
        filteredData = this.onlineMeters;
        break;
      case 'offline':
        filteredData = this.offlineMeters;
        break;
      case 'normal':
        filteredData = this.noAlertMeters;
        break;
      case 'alert':
        filteredData = this.alertGeneratedMeters;
        break;
      default:
        filteredData = this.totalMeters;
    }
    // Set dataSource for the first table
    this.dataSource = new MatTableDataSource(filteredData);
    this.dataSource.paginator = this.paginator; // Ensure paginator is linked
    // Set dataSource for the second table
    this.dataSourcetwo = new MatTableDataSource(this.alertsectiondata || []);
    this.dataSourcetwo.paginator = this.paginatorTwo; // Ensure paginator is linked
  }
  doFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.dataSourcetwo.filter = filterValue.trim().toLowerCase(); // Filter for the second table as well
  }
  close() {
    this.dialogRef.close();
  }
  open_individual(id: string) {
    console.log('Opening details for Meter:', id);
  }
  alertdata(id: string) {
    this.alertsData = `Alert for Meter ${id}`;
  }
}